module.exports = __webpack_public_path__ + "static/media/work-order.f4e7b07f.svg";